import { DiscreteEvent } from '@utils/customEvents'

export const PREFIX = '[LOOKUP] '

export type LookupFlow = 'ktn' | 'app-status'
export type SearchType = 'biographics' | 'applicationId'

export type LookupPipeMeta = {
  xCLEARCorrelationInfo: string
  lookupFlowSessionId: string
  flow: LookupFlow
  searchType: SearchType | ''
  route: string
  flagEnabled: string
}

export type ResultMeta = { [key: string]: unknown }

export type SearchResult = (
  | { status: 'begin'; searchType: SearchType }
  | {
      status: 'success'
      code: string
      hasOtpSessionId: boolean
      needCommMethod?: boolean
      disambiguation?: boolean
    }
  | { status: 'failure'; error: unknown; code: string }
) &
  ResultMeta

export type DisambiguationResult = (
  | { status: 'begin' }
  | { status: 'success'; code?: string }
  | { status: 'failure'; error: unknown; code: string }
) &
  ResultMeta

export type SendOTPResult = (
  | { status: 'begin' }
  | { status: 'success'; code?: string }
  | { status: 'failure'; error: unknown; code: string }
) &
  ResultMeta

export type VerifyOTPResult = (
  | { status: 'begin' }
  | { status: 'success'; code?: string }
  | { status: 'failure'; error: unknown; code: string }
) &
  ResultMeta

export type LookupResult = (
  | { status: 'begin' }
  | { status: 'success'; code: string }
  | { status: 'failure'; error: unknown; code: string }
) &
  ResultMeta

export type ResultShownResult = {
  code: string
  provider?: string
  ktn?: string
  applicationId?: string
} & ResultMeta

export const LookupDiscreteEvent = {
  LOOKUP_VIEW: 'LookupView' as DiscreteEvent,
  LOOKUP_SEARCH_BEGIN: 'LookupSearchBegin' as DiscreteEvent,
  LOOKUP_SEARCH_SUCCESS: 'LookupSearchSuccess' as DiscreteEvent,
  LOOKUP_SEARCH_FAILURE: 'LookupSearchFailure' as DiscreteEvent,
  LOOKUP_DISAMBIGUATION_BEGIN: 'LookupDisambiguationBegin' as DiscreteEvent,
  LOOKUP_DISAMBIGUATION_SUCCESS: 'LookupDisambiguationSuccess' as DiscreteEvent,
  LOOKUP_DISAMBIGUATION_FAILURE: 'LookupDisambiguationFailure' as DiscreteEvent,
  LOOKUP_SEND_OTP_BEGIN: 'LookupSendOTPBegin' as DiscreteEvent,
  LOOKUP_SEND_OTP_SUCCESS: 'LookupSendOTPSuccess' as DiscreteEvent,
  LOOKUP_SEND_OTP_FAILURE: 'LookupSendOTPFailure' as DiscreteEvent,
  LOOKUP_VERIFY_OTP_BEGIN: 'LookupVerifyOTPBegin' as DiscreteEvent,
  LOOKUP_VERIFY_OTP_SUCCESS: 'LookupVerifyOTPSuccess' as DiscreteEvent,
  LOOKUP_VERIFY_OTP_FAILURE: 'LookupVerifyOTPFailure' as DiscreteEvent,
  LOOKUP_RESULT_BEGIN: 'LookupResultBegin' as DiscreteEvent,
  LOOKUP_RESULT_SUCCESS: 'LookupResultSuccess' as DiscreteEvent,
  LOOKUP_RESULT_FAILURE: 'LookupResultFailure' as DiscreteEvent,
  LOOKUP_RESULT_SHOWN: 'LookupResultShown' as DiscreteEvent,
  LOOKUP_FLOW_CONCLUDED: 'LookupFlowConcluded' as DiscreteEvent,
} as const
